import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { environment } from 'src/environments/environment';
import { KmsService } from '../../kms.service';
declare var $;

@Component({
  selector: 'app-recently-edit-list',
  templateUrl: './recently-edit-list.component.html',
  styleUrls: ['./recently-edit-list.component.css']
})
export class RecentlyEditListComponent implements OnInit {
  // 向父组件传值
  @Output() componentState = new EventEmitter();
  navs:any = [
    {id:'1',text:'实体'},
    {id:'2',text:'关系'},
    // {id:'3',text:'图像'}
  ];
  selectId:string = '1';
  // 实体表格搜索数据集合
  searchDatas:any = {
    keyword: '',             // 实体名称
    approvalStatus: null,    // 状态
    editorUserId: '',        // 责任编辑
    onlyMe: false,           // 只看我的
    startNodeId:'',
    endNodeName: '',
    targetNodeId:'',
    keyword1: '',             // 图像名称
    approvalStatus1: null,    // 状态
    editorUserId1: '',        // 责任编辑
    onlyMe1: false,           // 只看我的
  }
  // 用户角色
  userRole = '';
  // 用户id
  userId = '';
  recordDatas:any = [];
  pageBase = {
      current: 1,
      size: 30
  }
  constructor(
    private jwt: SwJwtService,
    private User: GetUserModelService, //获取用户服务
    private kmsService: KmsService,
    private message: SwMassageBoxService
  ) { }

  ngOnInit() {
    // 获取用户id
    let user = this.User.getUser();
    this.userId = user['userId'];
    // 获取用户角色
    this.userRole = this.jwt.getToken('userRole');
    // 根据当前用户角色设置只看我的
    this.setOnlyMe();
  }

  setNav(data){
    if(this.selectId == data.id){
      return;
    }
    this.recordDatas = [];
    if(data.id === '2' && !this.searchDatas.startNodeId && !this.searchDatas.targetNodeId){
      this.selectId = data.id;
      return;
    }
    this.selectId = data.id;
    this.handleSearchClick();
  }

  // 根据当前用户角色设置只看我的
  setOnlyMe(){
    if(this.userRole == '知识编辑'){
      this.searchDatas.onlyMe = true;
      this.searchDatas.editorUserId = this.userId;
      this.searchDatas.approvalStatus = 1;

      this.searchDatas.onlyMe1 = true;
      this.searchDatas.editorUserId1 = this.userId;
      this.searchDatas.approvalStatus1 = 1;
    }
    this.handleSearchClick();
  }

  // 选中或取消选中只看我的
  onlyMeChange(){
    if(this.selectId === '1'){
      if(this.searchDatas.onlyMe){
        this.searchDatas.editorUserId = this.userId;
        this.searchDatas.approvalStatus = 1;
      }else{
        this.searchDatas.editorUserId = '';
        this.searchDatas.approvalStatus = null;
      }
    }else{
      if(this.searchDatas.onlyMe1){
        this.searchDatas.editorUserId1 = this.userId;
        this.searchDatas.approvalStatus1 = 1;
      }else{
        this.searchDatas.editorUserId1 = '';
        this.searchDatas.approvalStatus1 = null;
      }
    }
    this.handleSearchClick();
  }

  // 起始实体或指向实体发生变化
  handleInstanceChange(event){
    this.searchDatas.endNodeName = event.text;
  }

  // 搜索实体
  handleSearchClick(){
    this.pageBase = {
        current: 1,
        size: 30
    }
    this.getRecordDatas();
  }

  // 表格分页点击方法
  handlePageClick(event) {
    this.pageBase = event;
    this.getRecordDatas();
  }

  // 获取实体表格列表数据
  getRecordDatas() {
    if(this.selectId === '1'){
      let Params = {
          current: this.pageBase.current,
          size: this.pageBase.size,
          isDelete: false,
          instanceName: $.trim(this.searchDatas.keyword),
          approvalStatus: this.searchDatas.approvalStatus,
          editorUserId: this.searchDatas.editorUserId,
          orderBy: 2
      };
      this.kmsService.getInstanceQueryList(Params).subscribe(
          result => {
              if (result.code == 200) {
                  this.pageBase = result.data;
                  this.recordDatas = result.data.records;
                  if(this.recordDatas.length == 0){
                    this.message.waring('很抱歉，暂未查询到任何数据！');
                  }
              } else {
                  this.message.waring(result.msg);
              }
          }
      );
    }
    if(this.selectId === '2'){
      if(!this.searchDatas.startNodeId && !this.searchDatas.targetNodeId){
        this.message.waring('请至少选择一个实体！');
        return;
      }
      let params = {
        current: this.pageBase.current,
        size: this.pageBase.size,
        startNode: {
          nodeId: this.searchDatas.startNodeId
        },
        endNode: {
          nodeName: this.searchDatas.endNodeName
        }
      };
      this.kmsService.getRelationshipList(params).subscribe((data) => {
        if (data.code == "200") {
          this.pageBase = data.data;
          this.recordDatas = data.data.records;
          if(this.recordDatas.length == 0){
            this.message.waring('很抱歉，暂未查询到任何数据！');
          }
        } else {
          this.message.waring(data.msg);
        }
      });
    }
    if(this.selectId === '3'){
      let Params = {
          current: this.pageBase.current,
          size: this.pageBase.size,
          materialTitle: $.trim(this.searchDatas.keyword1),
          materialCategory: 'FILE_TYPE_PICTURE',
          approvalStatus: this.searchDatas.approvalStatus1,
          editorUserId: this.searchDatas.editorUserId1
      };
      this.kmsService.queryMaterialListByParams(Params).subscribe(
        result => {
            if (result.code == 200) {
                this.pageBase = result.data;
                this.recordDatas = result.data.records;
                if(this.recordDatas.length == 0){
                  this.message.waring('很抱歉，暂未查询到任何数据！');
                  return;
                }
                this.recordDatas.forEach(item => {
                    if (item.fileThumbnail) {
                        item["src"] = environment.staticFileUrl + item.fileThumbnail;
                    } else if (item.filePath) {
                        item["src"] = environment.staticFileUrl + item.filePath;
                    }
                })
            } else {
                this.message.waring(result.msg);
            }
        }
      );
    }
  }

  // 重置
  handleReloadClick(){
    if(this.selectId === '1'){
      this.searchDatas.keyword = '';
      this.searchDatas.approvalStatus = null;
      this.searchDatas.editorUserId = '';
      this.searchDatas.onlyMe = false;
      this.handleSearchClick();
    }
    if(this.selectId === '2'){
      this.searchDatas.startNodeId = '';
      this.searchDatas.targetNodeId = '';
      this.searchDatas.endNodeName = '';
      this.recordDatas = [];
    }
    if(this.selectId === '3'){
      this.searchDatas.keyword1 = '';
      this.searchDatas.approvalStatus1 = null;
      this.searchDatas.editorUserId1 = '';
      this.searchDatas.onlyMe1 = false;
      this.handleSearchClick();
    }
  }

  setDisabled(data){
    if(this.userRole == '超级管理员' || this.userRole == '其他'){
      return true;
    }
    if(this.userRole == '知识库管理员' && data.approvalStatus == 5){
      return true;
    }
    if(this.userRole == '知识编辑' && (data.approvalStatus !== 1 || this.userId != data.editorUserId )){
      return true;
    }
    if(this.userRole == '知识质检' && (data.approvalStatus !== 3 || this.userId != data.checkUserId )){
      return true;
    }
    return false;
  }

  selectData(item){
    if(this.selectId === '1' || this.selectId === '3'){
      const disabled = this.setDisabled(item);
      if(disabled){
        this.message.waring('很抱歉，当前数据无编辑权限！');
        return;
      }
    }
    this.clickToolbar('close');
    setTimeout(()=>{
      if(this.selectId === '1'){
        this.jwt.setToKen('instanceInfo',JSON.stringify({'upOrAdd': 'Edit','instanceData':item}));
        $('#quickEditInstance').trigger('click');
      }
      if(this.selectId === '2'){
        this.jwt.setToKen('relationInfo',JSON.stringify({'upOrAdd': 'Edit','relationData':item}));
        $('#quickEditRelation').trigger('click');
      }
      if(this.selectId === '3'){
        item['mode'] = 'edit';
        this.jwt.setToKen('imgInfo',JSON.stringify({'upOrAdd': 'markImg','imgData':item}));
        $('#quickMarkImg').trigger('click');
      }
    },500);
  }

  // 头部按钮点击事件
  clickToolbar(state){
    switch(state){
        case 'close': {
            this.componentState.emit(state);
            break;
        }
    }
  }
}
